import { Dispatch, ThunkAction } from '../../../../../../../../types/actions';
import { commentUpdate } from '../../../store/reducers/actions/commentUpdate';

export const onBlur = (): ThunkAction => {
    return (dispatch: Dispatch) => {
        dispatch(commentUpdate({ mentionSubstring: '' }));
    };
};
